import { render, staticRenderFns } from "./SidebarBoards.vue?vue&type=template&id=73ede706&scoped=true&"
import script from "./SidebarBoards.vue?vue&type=script&lang=js&"
export * from "./SidebarBoards.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBoards.vue?vue&type=style&index=0&id=73ede706&prod&scoped=true&lang=css&"
import style1 from "./SidebarBoards.vue?vue&type=style&index=1&id=73ede706&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ede706",
  null
  
)

export default component.exports